import { render, staticRenderFns } from "./FaqExpansionPanel.vue?vue&type=template&id=599b5439"
import script from "./FaqExpansionPanel.vue?vue&type=script&lang=ts"
export * from "./FaqExpansionPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports